import Driver from '../components/views/driver/Driver.vue'
import DriverCreate from '../components/views/driver/DriverCreate.vue'
import DriverDetail from '../components/views/driver/DriverDetail.vue'
import ExpiringLicense from '../components/views/dashboard/ExpiringLicense.vue'

const routes = [{
        path: 'driver',
        component: Driver,
        name: 'Driver',
        meta: {
            description: 'List of Think Gas Drivers',
            title: 'Drivers',
            requiresAuth: true
        }
    },

    {
        path: '/driver/create',
        component: DriverCreate,
        name: 'DriverCreate',
        meta: {
            description: 'Add a new Driver',
            title: 'Add Driver',
            requiresAuth: true
        }
    },
    {
        path: '/driver/:_id',
        beforeEnter: (to, from, next) => {
            to.params._id === 'create' ? next({ name: 'DriverCreate' }) : next()
        },
        component: DriverDetail,
        name: 'DriverDetail',
        meta: {
            description: 'Details for the selected driver',
            title: 'Update Driver',
            requiresAuth: true
        }
    },
    {
        path: 'expiringLicense',
        component: ExpiringLicense,
        name: 'ExpiringLicense',
        meta: {
            title: 'Drivers',
            description: 'ThinkGas Driver whose license are expiring within 2 months'
        }
    }
]


export default routes


// WEBPACK FOOTER //
// ./src/routes/driver.route.js